import React from "react";
import { useRouter } from "next/router";
import { fetchAllSales, fetchSale } from "Features/Api";
import PageHome from "Screens/Home";
import trackPageview from "Utils/analitics/google";

const Sale = ({ customData, ...props }) => {
    trackPageview();
    const router = useRouter();
    const { sale } = router.query;

    if (router.isFallback) {
        return <meta httpEquiv="refresh" content="0; URL='/'" />;
    }

    return customData && <PageHome {...props} customData={customData} />;
};

export async function getStaticPaths() {
    const [response] = await Promise.all([fetchAllSales()]);
    const json = await response.json();

    const paths = json.data.map((item) => ({
        params: {
            sale: item.slug,
        },
    }));

    return {
        paths,
        fallback: "blocking",
    };
}

export async function getStaticProps(context) {
    const [response] = await Promise.all([fetchSale(context.params.sale)]);
    const json = await response.json();

  if (!json || json.data.success === false) {
        return {
            redirect: {
                destination: "/",
                permanent: false,
            },
        };
    }

    json.data.items = json.data.items.map((item) => {
        return {
            id: item.id,
            eventName: item.event_name,
            name: item.name,
            months: item.interval_count,
            price: item.price,
        };
    });

    return {
        props: {
            customData: json.data,
        },
        revalidate: 3,
    };
}

export default Sale;
